import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider } from '@tokenforge/design-system';
import { router } from './routing/routes';
import { queryClient } from './lib/query-client';
import { AuthProvider } from './auth/AuthProvider';
import { FeatureFlagProvider } from './feature-flags/FeatureFlagProvider';
import { useAuthContext } from './auth/AuthProvider';

function AppProviders() {
  const { licenseTier } = useAuthContext();
  return (
    <FeatureFlagProvider licenseTier={licenseTier}>
      <RouterProvider router={router} />
    </FeatureFlagProvider>
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <AppProviders />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
